<div class="inner-pages properties-list desktop-properties listing agents hp-6 full bg-white-2 hd-white no-scroll-menu">
  <section class="properties-right list featured portfolio desktop-portfolio-list blog pt-5">
    <div class="container">
      <div class="row properties-top-data">
        <div class="col-lg-8 col-md-12 blog-pots">
          <section class="headings-2 pt-0 pb-4">
            <div class="pro-wrapper">
              <div class="detail-wrapper-body">
                <div class="listing-title-bar">
                  <div class="text-heading text-left">
                    <p class="font-weight-bold mb-0 mt-3">
                      {{ total }}
                      {{ "PROPERTIES.SEARCH-RESULTS.TEXT" | translate }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="cod-pad single detail-wrapper mr-2 mt-0 d-flex justify-content-md-end align-items-center grid">
                <div class="sortable-input input-group border-0 px-3 rounded input-group-lg mr-4">
                  <ng-select placeholder="{{ 't-order-by' | translate }}" [clearable]="false" [(ngModel)]="sortingValue"
                    [searchable]="false" [items]="sortingOptions" (change)="orderChange()"
                    [compareWith]="compareFn" bindValue="value">
                    <ng-template ng-label-tmp let-item="item">
                      <ion-icon name="swap-vertical-outline" class="me-2"></ion-icon>{{ item.name | translate }}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      {{ item.name | translate }}
                    </ng-template>
                  </ng-select>
                </div>
                <div class="sorting-options">
                  <a (click)="changeLayout(true)" [ngClass]="
                      stateView.value ? 'active-view-btn' : 'desactive-view'
                    " class="change-view-btn lde"><i class="fa fa-th-list"></i></a>
                  <a (click)="changeLayout(false)" [ngClass]="
                      !stateView.value ? 'active-view-btn' : 'desactive-view'
                    " class="change-view-btn"><i class="fa fa-th-large"></i></a>
                  <!-- <a [ngClass]="
                    isNearby ? 'active-view-btn' : 'desactive-view'
                  " class="change-view-btn"><i class="fa fa-th-large"></i></a> -->
                </div>
              </div>
            </div>
          </section>
          <div *ngIf="!properties && total != 0" class="mobile-loading">
            <div class="lds-roller">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div class="status-mes"></div>
          </div>
          <div class="no-results-properties" *ngIf="total === 0">
            <div class="no-results-icon">
              <ion-icon src="assets/new-icons/remove-circle-outline.svg"></ion-icon>
            </div>
            <div class="no-results-text d-flex justify-content-center">
              <span class="text-center">{{ "t-no-results-1" | translate }}
                <a (click)="clearFilters()" routerLink="/properties">{{
                  "t-no-results-2" | translate
                  }}</a></span>
            </div>
          </div>
          <app-grid-view *ngIf="!stateView.value" [properties]="properties"></app-grid-view>
          <app-list-view *ngIf="stateView.value" [properties]="properties"></app-list-view>
          <ngb-pagination *ngIf="total" [collectionSize]="total" [(page)]="page" [pageSize]="pageSize" [rotate]="true"
            [boundaryLinks]="true" [maxSize]="6" (pageChange)="refreshProperties()">
          </ngb-pagination>
        </div>
        <aside class="col-lg-4 col-md-12 car">
          <div class="widget">
            <!-- Search Fields -->
            <div *ngIf="searchData !== undefined && searchData !== null" class="widget-boxed main-search-field">
              <div class="widget-boxed-header">
                <h4>{{ "FILTERS.ADVANCED-TITLE.TEXT" | translate }}</h4>
              </div>
              <!-- Search Form -->
              <div *ngIf="initFilters" class="explore__form-checkbox-list search-home">
                <div class="row">
                  <div class="col-lg-12 col-md-6 py-1 pr-30 pl-0">
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        {{ "t-reference" | translate }}
                      </div>
                      <input class="form-control border-input" [(ngModel)]="searchForm.reference"
                        [ngModelOptions]="{ standalone: true }" placeholder="{{ 't-reference' | translate }}" />
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-6 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        {{ "t-district" | translate }}
                      </div>
                      <ng-select (change)="districtChange()" [(ngModel)]="selectedDistrict"
                        [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let district of searchData.locations" [value]="
                            district.countryId +
                            '-' +
                            district.id +
                            '-' +
                            district.regionId
                          ">{{ district.name }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-6 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        {{ "t-county" | translate }}
                      </div>
                      <ng-select (change)="countyChange()" [(ngModel)]="selectedCounty"
                        [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let c of county" [value]="c.id">{{ c.name }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-6 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        {{ "t-parish" | translate }}
                      </div>
                      <ng-select [(ngModel)]="selectedParish" [ngModelOptions]="{ standalone: true }"
                        [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let p of parish" [value]="p.id">{{ p.name }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-12 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        <ion-icon class="me-2" name="briefcase-outline"></ion-icon>{{ "FILTERS.BUSINESS.TEXT" |
                        translate }}
                      </div>
                      <ng-select [(ngModel)]="searchForm.businessType" (clear)="clearFilter('businessType')"
                        [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let bType of searchData?.businessType" [value]="bType.id">{{ bType.name
                          }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-12 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        <ion-icon class="me-2" name="business-outline"></ion-icon>{{ "FILTERS.PROPERTY-TYPE.TEXT" |
                        translate }}
                      </div>
                      <ng-select [(ngModel)]="searchForm.propertyType" (clear)="clearFilter('propertyType')"
                        [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let pType of searchData?.propertyType" [value]="pType.id">{{ pType.name
                          }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-12 py-1 pr-30 pl-0">
                    <!-- Form Property Status -->
                    <div class="form-group categories">
                      <div class="filter-title d-flex align-items-center justify-content-start mb-2">
                        <ion-icon class="me-2" name="construct-outline"></ion-icon>{{ "FILTERS.PROPERTY-STATE.TEXT" |
                        translate }}
                      </div>
                      <ng-select [(ngModel)]="searchForm.propertyCondition" (clear)="clearFilter('propertyCondition')"
                        [ngModelOptions]="{ standalone: true }" [placeholder]="'FILTERS.ANY.TEXT' | translate">
                        <ng-option *ngFor="let sType of searchData?.propertyCondition" [value]="sType.id">{{ sType.name
                          }}</ng-option>
                      </ng-select>
                    </div>
                    <!--/ End Form Property Status -->
                  </div>
                  <div class="col-lg-12 col-md-12 py-1 pr-30 pl-0 mt-3">
                    <!-- Form Bedrooms -->
                    <div class="form-group beds">
                      <div class="filter-title d-flex align-items-center text-center mb-2">
                        <ion-icon class="me-2" name="bed-outline"></ion-icon>{{ "FILTERS.BEDROOMS.TEXT" | translate }}
                      </div>
                      <ul class="nav nav-pills mb-3 d-flex align-items-center" id="pills-tab" role="tablist">
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button
                            [ngClass]="{'active': (!searchForm.bedrooms || searchForm.bedrooms == null) && searchForm.bedrooms != '0'}"
                            value="" class="nav-link" id="pills-home-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                            aria-selected="true">
                            {{ "FILTERS.ANY.TEXT" | translate }}
                          </button>
                        </li>
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bedrooms == '0'}" value="0" class="nav-link"
                            id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                            role="tab" aria-controls="pills-profile" aria-selected="false">
                            0
                          </button>
                        </li>
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bedrooms == '1'}" value="1" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            1
                          </button>
                        </li>
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bedrooms == '2'}" value="2" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            2
                          </button>
                        </li>
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bedrooms == '3'}" value="3" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            3
                          </button>
                        </li>
                        <li class="nav-item me-1 beds-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bedrooms == '4'}" value="4"
                            class="nav-link beds-last" id="pills-contact-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                            aria-selected="false">
                            4+
                          </button>
                        </li>
                      </ul>
                    </div>
                    <!--/ End Form Bedrooms -->
                  </div>
                  <div class="col-lg-12 col-md-12 py-1 pl-0 pr-30 mt-3">
                    <!-- Form Bathrooms -->
                    <div class="form-group bath">
                      <div class="filter-title d-flex align-items-center text-center mb-2">
                        <i class="fa fa-bath me-2" aria-hidden="true"></i>{{ "FILTERS.BATHROOMS.TEXT" | translate }}
                      </div>
                      <ul class="nav nav-pills mb-3 d-flex align-items-center" id="pills-tab" role="tablist">
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button
                            [ngClass]="{'active': (!searchForm.bathrooms || searchForm.bathrooms == null) && searchForm.bathrooms != '0'}"
                            value="" class="nav-link" id="pills-home-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home"
                            aria-selected="true">
                            {{ "FILTERS.ANY.TEXT" | translate }}
                          </button>
                        </li>
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bathrooms == '0'}" value="0" class="nav-link"
                            id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button"
                            role="tab" aria-controls="pills-profile" aria-selected="false">
                            0
                          </button>
                        </li>
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bathrooms == '1'}" value="1" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            1
                          </button>
                        </li>
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bathrooms == '2'}" value="2" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            2
                          </button>
                        </li>
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bathrooms == '3'}" value="3" class="nav-link"
                            id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button"
                            role="tab" aria-controls="pills-contact" aria-selected="false">
                            3
                          </button>
                        </li>
                        <li class="nav-item me-1 bath-items" role="presentation">
                          <button [ngClass]="{'active': searchForm.bathrooms == '4'}" value="4"
                            class="nav-link bath-last" id="pills-contact-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact"
                            aria-selected="false">
                            4+
                          </button>
                        </li>
                      </ul>
                    </div>
                    <!--/ End Form Bathrooms -->
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 py-1 mt-3 sld">
                    <!-- Price Fields -->
                    <div class="main-search-field-2">
                      <!-- Area Range -->
                      <div class="text-center">
                        <span class="d-flex align-items-center"><ion-icon class="me-2"
                            name="resize-outline"></ion-icon>{{
                          "FILTERS.AREA-RANGE.TEXT" | translate
                          }}
                          (m²)</span>
                        <div class="d-flex align-items-center mt-1 gap-1">
                          <input (change)="inputChange('area')" type="number"
                            class="form-control border-input w-50 area-value" [(ngModel)]="areaValue" />
                          <span>-</span>
                          <input (change)="inputChange('area')" type="number"
                            class="form-control border-input w-50 area-value" [(ngModel)]="areaMaxValue" />
                        </div>
                        <div class="clearfix"></div>
                      </div>
                      <br />
                      <!-- Price Range -->
                      <div class="text-center">
                        <span class="d-flex align-items-center">
                          <ion-icon class="me-2" name="cash-outline"></ion-icon>{{ "FILTERS.PRICE-RANGE.TEXT" |
                          translate }}
                        </span>
                        <div class="d-flex align-items-center mt-1 gap-1">
                          <input (change)="inputChange('price')" type="number"
                            class="form-control border-input w-50 area-value" [(ngModel)]="priceValue" />
                          <span>-</span>
                          <input (change)="inputChange('price')" type="number"
                            class="form-control border-input w-50 area-value" [(ngModel)]="priceMaxValue" />
                        </div>
                        <div class="clearfix"></div>
                        <div class="clearfix"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- More Search Options -->
              <a [ngClass]="{ active: otherChars }" (click)="otherChars = !otherChars"
                class="more-search-options-trigger margin-bottom-10 margin-top-30">{{ "FILTERS.ADVANCED.TEXT" |
                translate }}</a>

              <div [ngClass]="{ 'active d-block': otherChars }" class="more-search-options relative">
                <!-- Checkboxes -->
                <div class="checkboxes one-in-row margin-bottom-10 ch-1 row">
                  <div *ngFor="let char of searchData.characteristics" class="col-12">
                    <input [checked]="checkedCharacteristics.includes(char.id)" (change)="updateChars(char.id)"
                      id="check-char-{{ char.id }}" type="checkbox" name="check" />
                    <label for="check-char-{{ char.id }}">{{
                      char.name
                      }}</label>
                  </div>
                </div>
                <!-- Checkboxes / End -->
              </div>
              <!-- More Search Options / End -->
              <div class="col-lg-12 no-pds">
                <div class="at-col-default-mar">
                  <button (click)="filterSearch()" class="btn btn-default hvr-bounce-to-right" type="submit">
                    {{ "HOME.SEARCH.TEXT" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="highlightsProperties && highlightsProperties.length > 0">
              <div class="widget-boxed mt-5">
                <div class="widget-boxed-header pb-0 similar-property mb-3">
                  <h5>{{ "HOME.HIGHLIGHTS.TEXT" | translate }}</h5>
                </div>
                <div class="featured-change-slide mt-2 w-100" style="height: 40px">
                  <div class="float-end h-100 next-featured w-25">
                    <ion-icon (click)="changeFeatured('next', slickHighlightsDesktop)" name="chevron-forward-outline"
                      role="img" class="float-end c-pointer fs-2 hydrated md pe-3"
                      aria-label="chevron forward outline"></ion-icon>
                  </div>
                  <div class="float-end h-100 prev-featured w-25">
                    <ion-icon (click)="changeFeatured('prev', slickHighlightsDesktop)" name="chevron-back-outline"
                      role="img" class="float-end c-pointer fs-2 hydrated md"
                      aria-label="chevron back outline"></ion-icon>
                  </div>
                </div>
                <div class="widget-boxed-body overflow-hidden pt-2">
                  <div #slickHighlightsDesktop [style.width]="highlightsProperties.length * 100 + '%'"
                    id="slick-highlights-desktop">
                    <div id="featured-property-{{ i }}" *ngFor="
                        let highlight of highlightsProperties;
                        let i = index
                      " [ngClass]="{ active: i === activeFeatured }" class="agents-grid w-100 mr-0">
                      <div class="listing-item compact h-100">
                        <a [routerLink]="
                            highlight.propertyTypeId === 96
                              ? utilsPropertiesService.generateEnterpriseLink(
                                  highlight.title,
                                  highlight.uniqueId
                                )
                              : utilsPropertiesService.generateRouterLink(
                                  highlight.title,
                                  highlight.uniqueId
                                )
                          " class="listing-img-container">
                          <div *ngIf="highlight?.businessType" class="listing-badges">
                            <span>{{ highlight.businessType}}</span>
                          </div>
                          <div class="listing-img-content">
                            <span class="listing-compact-title"><span>{{ highlight.title }}</span><i>{{
                                highlight.district }}</i></span>
                            <ul class="listing-hidden-content">
                              <li>
                                {{ "t-price" | translate }}:
                                <span>{{
                                  highlight.price != 0 &&
                                  highlight.price != null
                                  ? priceFormat(highlight.price, highlight?.currency)
                                  : ("t-on-request" | translate)
                                  }}</span>
                              </li>
                              <li>
                                {{ "t-reference" | translate }}:
                                <span>{{ highlight.reference }}</span>
                              </li>
                            </ul>
                          </div>
                          <img [src]="highlight.media[0].file" class="h-100" alt="highlight-{{ i }}" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  </section>
</div>
